<template>
  <div class="individual-analysis">
    <template v-if="showSamples">
      <sample-view
        :sample-id="currentSampleId"
        :asset-module-id="assetModuleId"
        :key="currentSampleId"
      />
      <samples-paginator
        v-if="!isSingleSampleView"
        v-model="currentSampleId"
        :samples="paginator"
      />
    </template>
    <s-empty-list
      v-else
      :loading="loading"
    />
  </div>
</template>

<script>
import LoadingMixin from '@/services/loadingMixin';
import IndividualAnalysisService
  from '@/domain/services/installation/engineering/chromatography/individualAnalysis';
import { compareFor } from '@/services/sortHelper';
import comparator from '@/services/comparationHelpers';
import SampleView from './SampleView';
import SamplesPaginator from './SamplesPaginator';

export default {
  props: {
    sampleIds: Array,
    assetModuleId: String,
  },
  components: {
    SampleView,
    SamplesPaginator,
  },
  mixins: [
    LoadingMixin,
  ],
  data: () => ({
    samples: null,
    currentSampleId: null,
  }),
  computed: {
    paginator() {
      const pages = this.sampleIds
        .map(it => this.samples
          .find(({ id }) => comparator.compareIds(id, it)));
      return pages.sort((a, b) => a.number - b.number);
    },
    showSamples() {
      return !this.loading && this.hasSamples;
    },
    hasSamples() {
      return this.samples && this.samples.length > 0;
    },
    isSingleSampleView() {
      return this.sampleIds.length === 1;
    },
    currentSampleHandler() {
      return (this.sampleIds && Array.isArray(this.sampleIds))
        ? this.paginator[0].id : this.sampleIds;
    },
  },
  methods: {
    loadSampleData() {
      this.startLoading();
      IndividualAnalysisService.getSampleList(this.assetModuleId, this.sampleIds)
        .then((data) => {
          this.samples = data;
          this.samples.sort(compareFor('number'));
          this.currentSampleId = this.currentSampleHandler;
        })
        .finally(() => {
          this.endLoading();
      });
    },
  },
  created() {
    this.loadSampleData();
  },
};
</script>
<style lang="sass" scoped>
  .individual-analysis
    display: flex
    flex-direction: column
    width: 100%
</style>
